import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Mail, MapPin } from 'lucide-react';
import Logo from '../Logo';
import { ENV } from '../../config/env';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="pf-footer mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="space-y-4">
            <Logo to="/" size={36} variant="light" />
            <p className="text-sm leading-relaxed max-w-xs">
              A marketplace connecting pet owners with independent caregivers across India. Book, chat, and manage care in one place.
            </p>
            <div className="flex items-center gap-2 text-sm">
              <MapPin className="w-4 h-4 shrink-0 text-blue-300" />
              <span>Hyderabad · Bangalore · Mumbai</span>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">For owners</h3>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/search">Find caregivers</Link></li>
              <li><Link to="/how-it-works">How it works</Link></li>
              <li><Link to="/owner-pets">Pet profiles</Link></li>
              <li><Link to="/testimonials">Testimonials</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">For caregivers</h3>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/become-caregiver">Become a caregiver</Link></li>
              <li><Link to="/caregiver-dashboard">Caregiver dashboard</Link></li>
              <li><Link to="/blog">Blog & resources</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Legal</h3>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/terms">Terms of service</Link></li>
              <li><Link to="/privacy">Privacy policy</Link></li>
              <li>
                <a href={`mailto:${ENV.APP.SUPPORT_EMAIL}`} className="inline-flex items-center gap-2">
                  <Mail className="w-4 h-4" />
                  {ENV.APP.SUPPORT_EMAIL}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm">
          <p>© {year} {ENV.APP.NAME}. All rights reserved.</p>
          <p className="inline-flex items-center gap-1.5">
            Made with <Heart className="w-4 h-4 text-pink-400 fill-pink-400" /> for pets and their people
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
